<script>
export default {
    name: 'Project',
    props: {
        id: { type: Number, default: null },
        title: String,
        description: String,
        organisation: String,
        link: String,
        featured: Boolean,
        status: { type: String, default: null },
        editMode: { type: Boolean, default: false },
    },
    data: () => {
        return {
            showDescription: false,
        }
    },
    methods: {
        toggleDescription() {
            this.showDescription = !this.showDescription;
        },
        onEdit() {
            this.$router.push(this.$route.path + '/project/edit/' + this.id);
        },
        onDelete() {
            this.$router.push(this.$route.path + '/project/delete/' + this.id);
        }
    },
    computed: {
        statusLabel() {
            return this.status === 'draft' ? this.$t('project.statusDraft') : '';
        },
    }
};
</script>

<template>
    <article class="project" v-bind:class="[{ 'project--featured': featured }, , { 'project--editable': editMode }]">
        <div class="project__content">
            <h1 class="project__title">
                <span v-html="title"></span>
                <span class="project__status" v-if="statusLabel">{{statusLabel}}</span>
            </h1>
            <p class="project__description" v-if="description && showDescription">{{ description }}</p>
            <p class="project__organisation">{{ organisation }}</p>
            <a v-bind:href="link" class="project__link read-more" target="_blank">{{ $t('project.moreInfo')}}</a>
            <button 
                class="project__description-toggle"
                v-if="description" 
                v-on:click="toggleDescription" 
                v-bind:class="{'project__description-toggle--open': showDescription}">
            </button>
            <ul class="project__actions" v-if="editMode">
                <li class="project__action">
                    <button class="project__action-btn project__action-btn--edit" v-on:click="onEdit()"></button>
                </li>
                <li class="project__action">
                    <button class="project__action-btn project__action-btn--delete" v-on:click="onDelete()"></button>
                </li>
            </ul>
        </div>
    </article>
</template>

<style lang="scss" scoped>
.project {
    position: relative;
    box-sizing: border-box;
    min-height: 11.6rem;
    padding: 0.96rem 0 3.2rem;
    border-bottom: 0.1rem solid rgba($color-primary, .15);
}

.project__content {
    max-width: 56rem;

    @include breakpoint('sm-down') {
        padding-right: 3.2rem;
    }
}
.project--editable .project__content {
    padding-right: 12rem;
}
.project__title {
    font-size: 2.08rem;
    font-weight: normal;
    letter-spacing: 0.057rem;
    line-height: 1.15;
    margin: 0 0 0.32rem;
}
.project__status {
    display: inline-block;
    margin: 0 0.64rem;
    padding: 0.192rem 0.48rem;
    font-size: 1.4rem;
    text-transform: uppercase;
    letter-spacing: 0.08rem;
    vertical-align: middle;
    color: $color-light;
    background: $color-primary;
}
.project__description {
    margin: 0 0 0.96rem;
    line-height: 1.3;
}
.project__organisation {
    margin: 0;
    line-height: 1.3;
}
.project__link read-more {
    display: block;
    margin: 1.28rem 0 0;
}

.project__description-toggle {
    position: absolute;
    top: 1.6rem; right: 0;
    width: 3.36rem; height: 3.36rem;
    margin: -1.68rem 0;
    border: none;
    outline: none;
    background: center url(~@/assets/images/ico-chevron-bottom-gray.svg) no-repeat;
    cursor: pointer;
}
.project__description-toggle--open {
    transform: rotate(180deg);
}

.project__actions {
    position: absolute;
    top: 0.96rem; right: 4rem;
    display: flex;
    margin: 0 -0.4rem;
    padding: 0;
}
.project__action {
    display: block;
    margin: 0 0.4rem
}
.project__action-btn {
    width: 2.4rem; height: 2.4rem;
    outline: none;
    border: none;
    margin: 0;
    padding: 0;
    background: center transparent no-repeat;
    cursor: pointer;
}
.project__action-btn--edit {
    background-image: url('~@/assets/images/ico-edit.svg');
}
.project__action-btn--delete {
    background-image: url('~@/assets/images/ico-delete.svg');
}
</style>
